import {
  TextField,
  IndexTable,
  LegacyCard,
  IndexFilters,
  useSetIndexFiltersMode,
  useIndexResourceState,
  Text,
  ChoiceList,
  RangeSlider,
  Badge,
} from "@shopify/polaris";
import { useState, useCallback, useEffect } from "react";

import Products  from "../Products";
import Axios from "./Axios";
import { Steps, Hints } from 'intro.js-react';

function SearchBar({ fetchproduct , whichPage}) {
  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
  const [productNotExists, setProductNotExists] = useState(false);
  const [products, setProducts] = useState([]);
  const [allProductCount,setAllProductCount] = useState();

const [stepsEnabled,setStepsEnabled] = useState(false);
  useEffect(()=>{ 
        const fetchCountProudcts = async()=>{
          setStepsEnabled(true);
        try {
          if (whichPage === 'products') {
            
            const response = await Axios.get('/product/getProductCount');
            const counts = response.data;            
            setAllProductCount(counts);
          }
          if (whichPage === 'Unlinked') {
             const response = await Axios.get('/shopify/getProductCount');
              const counts = response.data;            
              setAllProductCount(counts);
            
          }
        } catch (error) {
          
        }
      }
      fetchCountProudcts();
  },[fetchproduct])
  
  const [itemProducts, setItemProducts] = useState([
    `All`,
    `Ready To Import`,
    "Imported",
    "Import In Progress",
    "ReImport In Progress",
    "Error",
  ]);
  const [itemListings, setItemListings] = useState([
    "Ebay",
    "Shopify",

  ]);
  const [itemUnListings, setItemUnListings] = useState([
    "All",
    "UnLinked",
    "Imported",
    "Import In Progress",
    "Linked",
    "Error",
  ]);
  
const tabsUL = itemUnListings.map((item, index) => {
  const label = item.replace(/\s\d+$/, '').trim();
  let badgeValue = 0;

  if (allProductCount) {
    if (label === 'All') {
      badgeValue = allProductCount.all_count;
    } else if (label === 'UnLinked') {
      badgeValue = allProductCount.unlinked_count;
    } else if (label === 'Imported') {
      badgeValue = allProductCount.imported_count;
    } else if (label === 'Linked') {
      badgeValue = allProductCount.linked_count;
    } else if (label === 'Error') {
      badgeValue = allProductCount.error_count;
    } else if (label === 'Import In Progress') {
      badgeValue = allProductCount.import_in_progress_count;
    }
  }

  return {
    content: item,
    badge: badgeValue,
    index,

    onAction: () => {
      fetchproduct(label);
    },
    id: `${item}-${index}`,
    isLocked: index === 0,
    actions: index === 4 ? [] : [],
  };
});

  const tabsL = itemListings.map((item, index) => ({
    content: item,
    index,
    onAction: () => {
      fetchproduct(item)
    },
    id: `${item}-${index}`,
    isLocked: index === 0,
    actions:
      index === 0
        ? []
        : [],
  }));
const tabsP = itemProducts.map((item, index) => {
  const label = item.replace(/\s\d+$/, '').trim(); // Extract label
  const match = item.match(/\d+$/); // Extract count
  let badgeValue = 0; 
  let id='';
  if (allProductCount) {
    if (item === 'All') {
        badgeValue = allProductCount.all_count;
      }
    if (item === 'Ready To Import') {
      badgeValue = allProductCount.ready_to_import_count;
    }
     if (item === 'Import In Progress') {
      badgeValue = allProductCount.import_in_progress_count;
    } 
    if (item === 'Imported') {
      badgeValue = allProductCount.imported_count;
    }
    if (item === 'Error') {
      badgeValue = allProductCount.error_count;
    }
    if (item === 'ReImport In Progress') {
      badgeValue = allProductCount.reimport_in_progress_count;
    }
  }
  return {
    
    content: item,
    badge: badgeValue, 
    index,
    id:id,
    onAction: () => {
      if (label !== 'All') {
        fetchproduct(label);
      } else {
        fetchproduct('All');
      }
    },
    id: `${item}-${index}`,
    isLocked: index === 0,
    actions: index === 0 ? [] : [],
  };
});
  const [selected, setSelected] = useState(0);
  const onCreateNewView = async (value) => {
    await sleep(500);
    setItemProducts([...itemProducts, value]);
    setSelected(itemProducts.length);
    return true;
  };

  const options = [
    {label: 'Newest Products', value: 'newestProduct'},
    {label: 'Oldest Products', value: 'oldestProduct'},
    {label: ' Title A–Z', value: 'AZ'},
    {label: ' Title Z–A', value: 'ZA'},
  ];

  const sortOptions = [
    {label: 'Product', value: 'Product asc', directionLabel: 'Ascending'},
    {label: 'Product', value: 'Product desc', directionLabel: 'Descending'},
    { label: "Title", value: "Title asc", directionLabel: "Title asc" },
      { label: "Title", value: "Title desc", directionLabel: "Title desc" },

  ];
  const [sortSelected, setSortSelected] = useState(["Product asc"]);


  const { mode, setMode } = useSetIndexFiltersMode();
  const onHandleCancel = () => {};

  const onHandleSave = async () => {
    await sleep(1);
    return true;
  };

  const primaryAction =
    selected === 0
      ? {
          type: "save-as",
          onAction: onCreateNewView,
          disabled: false,
          loading: false,
        }
      : {
          type: "save",
          onAction: onHandleSave,
          disabled: false,
          loading: false,
        };

  const [accountStatus, setAccountStatus] = useState();
  const [accountStatusUL, setAccountStatusUL] = useState();
  const [accountStatusL, setAccountStatusL] = useState();

  


  const [moneySpent, setMoneySpent] = useState();
  const [typeWith, setTypeWith] = useState("");
  const [VendorWith, setVendorWith] = useState("");
  const [SKUWith, setSKUWith] = useState("");


  const [queryValue, setQueryValue] = useState("");

  const showIntro = [
        {
            element: '#showImport',
            intro: 'Click here to view imported products.',
            position: 'right'
        }
  ];


  const handleAccountStatusChange = (value)=>{
    setAccountStatus(value)
    fetchproduct(value);
  } 
  const handleAccountStatusChangeUL = (value)=>{
    setAccountStatusUL(value)
    fetchproduct(value);
  } 
  const handleAccountStatusChangeL = (value)=>{
    setAccountStatusL(value)
    fetchproduct(value);
  } 
  const handleMoneySpentChange = useCallback(
    (value) => setMoneySpent(value),
    []
  );
  const handleTypeWithChange = useCallback(
    (value) => {
      setTypeWith(value);
      fetchproduct({ type: value });
    },
    [] // Optionally add dependencies like [fetchproduct] if needed
  );
  
  const handleVendorWithChange = useCallback(
    (value) => {
      setVendorWith(value);
      fetchproduct({ Vendor: value });
    },
    [] // Optionally add dependencies like [fetchproduct] if needed
  );
  const handleSKUWithChange = useCallback(
    (value) => {
      setSKUWith(value);
      fetchproduct({ sku: value });
    },
    [] // Optionally add dependencies like [fetchproduct] if needed
  );

  const handleSortChange = (value) => {

    setSortSelected(value)
    fetchproduct(value[0]);
  
  };
  const handleFiltersQueryChange = (value)=>{
    setQueryValue(value) 
    fetchproduct(value);
  }  
  const handleFiltersQueryChangeUL = (value) =>{
      setQueryValue(value) 
    fetchproduct(value);
  }
  const handleAccountStatusRemove = useCallback(
    () => setAccountStatus(undefined),

    []
  );
  const handleMoneySpentRemove = useCallback(
    () => setMoneySpent(undefined),
    []
  );
  const handletypeWithRemove = useCallback(() => setTypeWith(""), []);
  const handleQueryValueRemove = useCallback(() => setQueryValue(""), []);
  const handleFiltersClearAll = useCallback(() => {
    handleAccountStatusRemove();
    handleMoneySpentRemove();
    handletypeWithRemove();
    handleQueryValueRemove();
  }, [
    handleAccountStatusRemove,
    handleMoneySpentRemove,
    handleQueryValueRemove,
    handletypeWithRemove,
  ]);



  const filters = [
    {
      key: "productStatus",
      label: "Product status",
      filter: (
        <ChoiceList
          title="Product status"
          // titleHidden
          choices={[
            { label: "Ready To Import", value: "readytoimport" },
            { label: "Imported", value: "imported" },
            { label: "Import In Progress", value: "importinprogress" },
            { label: "Error", value: "error" },
            { label: "Already Exist", value: "AlreadyExist" },

          ]}
          selected={accountStatus || []}
          onChange={handleAccountStatusChange}
          allowMultiple
        />
      ),
      shortcut: true,
    }
  ];
  const handleShopifyfilter = ()=>{
    fetchproduct(typeWith);
  }
  const filtersUL = [
    {
      key: 'typeWith',
      label: 'Product Type with',
      
      filter: (
        <TextField
          label="Product Type with"
          value={typeWith}
          onChange={handleTypeWithChange}
          autoComplete="off"
          labelHidden
        />
      ),
      shortcut: true,
      pinned: true,

    },
    {
      key: 'VendorWith',
      label: 'Vendor with',
      filter: (
        <TextField
          label="Vendor with"
          value={VendorWith}
          onChange={handleVendorWithChange}
          autoComplete="off"
          labelHidden
        />
      ),
      shortcut: true,
      pinned: true,

    },
    {
      key: 'skuWith',
      label: 'SKU with',
      filter: (
        <TextField
          label="SKU with"
          value={SKUWith}
          onChange={handleSKUWithChange}
          autoComplete="off"
          labelHidden
        />
      ),
      shortcut: true,
      pinned: true,

    }   

  ];
  const filtersL = [
    {
      key: "productStatus",
      label: "Source",
      filter: (
        <ChoiceList
          title="Product status"
          // titleHidden
          choices={[
            { label: "Ebay", value: "Ebay" },
            { label: "Shopify", value: "Shopify" },
          ]}
          selected={accountStatus || []}
          onChange={handleAccountStatusChangeL}
          allowMultiple
        />
      ),
      shortcut: true,
    }
  ];
  const appliedFilters = [];
  if (accountStatus && !isEmpty(accountStatus)) {
    const key = "accountStatus";
    appliedFilters.push({
      key,
      label: disambiguateLabel(key, accountStatus),
      onRemove: handleAccountStatusRemove,
    });
  }
  if (accountStatusUL && !isEmpty(accountStatusUL)) {
    const key = "accountStatus";
    appliedFilters.push({
      key,
      label: disambiguateLabel(key, accountStatusUL),
      onRemove: handleAccountStatusRemove,
    });
  }

  if (!isEmpty(typeWith)) {
    const key = 'typeWith';
    appliedFilters.push({
      key,
      label: disambiguateLabel(key, typeWith),
      onRemove: handletypeWithRemove,

    });
  }
      const onExit = () => {
        setStepsEnabled(false);
    };

  return (

    <LegacyCard>
         <Steps
                    enabled={stepsEnabled}
                    steps={showIntro}
                    onExit={onExit}
                    options={{
                        nextLabel: 'Next',
                        prevLabel: 'Previous',
                        doneLabel: 'Done'
                    }}
                />
          { whichPage === "products" && (
          

           
              <IndexFilters
              sortOptions={sortOptions}
              autoFocusSearchField={true}
              sortSelected={sortSelected}
              filteringAccessibilityTooltip="Search and filter (F)"
              queryValue={queryValue}
              queryPlaceholder="Searching in all"
              onQueryChange={handleFiltersQueryChange}
              onQueryClear={() => setQueryValue("")}
              onSort={handleSortChange}
              cancelAction={{
                type: 'Cancel',
                content:"cancel",
                onAction: onHandleCancel,
               
              }}
              tabs={tabsP}
              selected={selected}
              onSelect={setSelected}
              onCreateNewView={onCreateNewView}
              filters={[]}
              appliedFilters={appliedFilters}
              onClearAll={handleFiltersClearAll}
              mode={mode}
              setMode={setMode}
              canCreateNewView={false}
            />
      
          )
          }
               { whichPage === "Unlinked" && (
              <IndexFilters
              sortOptions={sortOptions}
              sortSelected={sortSelected}
              queryValue={queryValue}
              queryPlaceholder="Searching in all"
              filteringAccessibilityTooltip="Search and filter (F)"
              onQueryChange={handleFiltersQueryChangeUL}
              onQueryClear={() => setQueryValue("")}
              onSort={handleSortChange}
              cancelAction={{
                onAction: onHandleCancel,
                disabled: false,
                loading: false,
              }}
              tabs={tabsUL}
              selected={selected}
              onSelect={setSelected}
              onCreateNewView={onCreateNewView}
              filters={filtersUL}
              appliedFilters={appliedFilters}
              onClearAll={handleFiltersClearAll}
              mode={mode}
              setMode={setMode}
              canCreateNewView={false}

            />
          )
          }
               { whichPage === "listings" && (
              <IndexFilters
              sortOptions={sortOptions}
              sortSelected={sortSelected}
              queryValue={queryValue}
              queryPlaceholder="Searching in all"
              onQueryChange={handleFiltersQueryChange}
              onQueryClear={() => setQueryValue("")}
              onSort={handleSortChange}
              primaryAction={primaryAction}
              cancelAction={{
                onAction: onHandleCancel,
                disabled: false,
                loading: false,
              }}
              tabs={tabsL}
              selected={selected}
              onSelect={setSelected}
              canCreateNewView={false}
              filters={[]}
              appliedFilters={appliedFilters}
              onClearAll={handleFiltersClearAll}
              mode={mode}
              setMode={setMode}
            />
          )
          }
 

    </LegacyCard>
  );

  function disambiguateLabel(key, value) {
    switch (key) {
      case "moneySpent":
        return `Money spent is between $${value[0]} and $${value[1]}`;
      case "typeWith":
        return `Tagged with ${value}`;
      case "accountStatus":
        return value.map((val) => `Customer ${val}`).join(", ");
      default:
        return value;
    }
  }

  function isEmpty(value) {
    if (Array.isArray(value)) {
      return value.length === 0;
    } else {
      return value === "" || value == null;
    }
  }
}

export default SearchBar;
